import { service } from ".";

export default {
  getAll: () => service.get("/sliders"),
  getOne: (id) => service.get(`/sliders/${id}`),
  getAllPaginate: (query) => service.get(`/sliders/paginate?${query}`),
  create: (data) => service.post("/sliders", data),
  update: (id, data) => service.put(`/sliders/${id}`, data),
  delete: (id) => service.delete(`/sliders/${id}`),
};
